var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"ivy-part"},[_vm._v(" IVY")]),_c('span',{staticClass:"ed-part"},[_vm._v("ED")])])}]

export { render, staticRenderFns }